import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.div`
  margin-top: 16rem;
  width: 100%;
  padding: 4rem 2rem;
  background: #040A19;
  color: white;
`;

const GridContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  position: relative;
  padding: 2rem;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(72, 171, 219, 0.1);
    transform: translateY(-5px);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
  }
`;

const Title = styled.h3`
  color: #48ABDB;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
`;

const Subtitle = styled.p`
  color: #d69de6;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 1.25rem;
`;

const Description = styled.p`
  color: white;
  font-size: 1.1rem;
  line-height: 1.6;
  opacity: 0.9;
`;

const FeaturesSection = () => {
  const features = [
    {
      title: "HEARTS CONFERENCE VIENNA",
      subtitle: null,
      description: "With over 400 participants yearly we are the biggest national conference connecting cardiology and cardiac surgery."
    },
    {
      title: "HEARTPORT LABS",
      subtitle: "SCIENCE4CARE - PIONEERS",
      description: "Events on medical science for a national and international audience across all specialties, from the cutting edge of established research to the first spark of a new scientific idea."
    },
    {
      title: "INTERNATIONAL RETREATS",
      subtitle: "HEARTSTEAM Winter Summit - HEARTS Washington DC",
      description: "Exclusive retreats for clinical decision makers to facilitate scientific exchange, enhance leadership, and shape the future of clinical care."
    },
    {
      title: "HEARTPORT EXPERT",
      subtitle: null,
      description: "Latest research, concisely summarized for busy doctors. HEARTPORT Expert translates current medical research into concise information, organized by specialty. We support busy doctors to keep track of the latest research, improving everyday clinical practice."
    },
    {
      title: "HEARTPORT PUBLIC",
      subtitle: null,
      description: "Build your best self with health science. Science for health optimization and prevention for everyone. HEARTPORT Public transforms original studies into easy-to-understand HEARTicles and brings evidence-based health knowledge into people's everyday lives, where it can make a difference."
    },
    {
      title: "SCIENCE4CARE INITIATIVE",
      subtitle: "Partner: Ärztekammer für Wien",
      description: "Science4Care actively supports and connects researchers for joint projects and scientific collaboration, with the help of AI. By bringing together the right scientific minds we foster new collaborations and drive innovation."
    },
    {
      title: "HEARTS MATCH",
      subtitle: null,
      description: "HEARTS Match brings research ideas and the right partners together. Researchers present their scientific abstracts along with proposals for future studies, and we match these ideas with suitable clinics and research centers at the conference to initiate new collaborative projects."
    },
    {
      title: "Guided Heartports: Your Health, Curated by Experts",
      subtitle: null,
      description: "A team of medical experts selects the most important and reliable content for targeted and efficient health promotion."
    },
    {
      title: "A New Dimension of Transparency",
      subtitle: null,
      description: "HEARTPORT not only refers to scientific studies, but also gives non-medical audiences insight into the scientific background information. Discover a new dimension of transparency in an age of misinformation."
    }
  ];

  return (
    <SectionWrapper>
      <GridContainer>
        {features.map((feature, index) => (
          <FeatureCard key={index}>
            <Title>{feature.title}</Title>
            {feature.subtitle && <Subtitle>{feature.subtitle}</Subtitle>}
            <Description>{feature.description}</Description>
          </FeatureCard>
        ))}
      </GridContainer>
    </SectionWrapper>
  );
};

export default FeaturesSection;
